import { render, staticRenderFns } from "./chanyefazhan.vue?vue&type=template&id=3cbd2e4e&"
import script from "./chanyefazhan.vue?vue&type=script&lang=js&"
export * from "./chanyefazhan.vue?vue&type=script&lang=js&"
import style0 from "./chanyefazhan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports